const InputText = choice => {

    return choice.aisId ? `${choice.name} (${choice.aisId})` : choice.name;
};

export default InputText;
